// router/index.tsx

import React from "react";
import { createHashRouter } from "react-router-dom";
import Login from "../pages/Login/Login";
import RegisteredSuccess from "../pages/Login/RegisteredSuccess";
import NewRegisteredSuccess from "../pages/Login/NewRegisteredSuccess";
import NewRegisteredSuccessTwo from "../pages/Login/NewRegisteredSuccessTwo";
import Register from "../pages/Login/Register";
import Index from "../pages/Login/index";
import IndexCopy from "../pages/Login/index-copy";

// ✅ 可配置：哪些域名用 IndexCopy
const useIndexCopyDomains = ["dzep.cc","zyd8.cc"]; // 可继续扩展

// 当前域名小写处理
const currentHost = window.location.origin.toLowerCase();

// 根据配置判断是否使用 IndexCopy
const useIndexCopy = useIndexCopyDomains.some((domain) =>
  currentHost.includes(domain)
);
console.log('useIndexCopy',useIndexCopy)

// 路由配置
const router = createHashRouter([
  {
    path: "/",
    element: useIndexCopy ? <IndexCopy /> : <Index />,
  },
  {
    path: "/Register",
    element: <Register />,
  },
  {
    path: "/login-test",
    element: <Login />,
  },
  {
    path: "/RegisteredSuccess",
    element: <RegisteredSuccess />,
  },
  {
    path: "/NewRegisteredSuccess",
    element: <NewRegisteredSuccess />,
  },
  {
    path: "/NewRegisteredSuccessTwo",
    element: <NewRegisteredSuccessTwo />,
  },
]);

export default router;
